import { allModelsSelector } from 'common-src/utils/selectorUtils';

export const getPatientCaregivers = (state, patientId) =>
  allModelsSelector(state, 'PatientCaregiver', (p) => p.patientId === patientId);

export const patientHasPrimaryCaregiver = (state, patientId) => {
  const caregivers = getPatientCaregivers(state, patientId);
  return caregivers.some((caregiver) => caregiver.isPrimary && !caregiver.deletedAt);
};

export const getActivePatientCaregivers = (state, patientId) =>
  getPatientCaregivers(state, patientId).filter((caregiver) => !caregiver.deletedAt);
